import React, { useEffect, useRef, useState } from "react";
import { videoInPhone } from "./homeHelper";
import { getScreenSize, phoneFrameDimensions } from "../globalConstants";
import { FlexiblePhone, FlexiblePhoneStillImage } from "./flexiblePhone";


export const VerticalPhoneWithVideo = ({ video, backupPhoto, scaleFactorInput }) => {
    const scaleFactor = scaleFactorInput ?? 1.2
    return (
        <div className="about-section-video" style={{

            display: "flex",
            position: "relative",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
            height: "100%",
            width: "100%",

        }}>
            <div
                className="about-section-video-container"
                style={{
                    padding: "4%",
                    objectFit: "contain",
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    position: "relative",
                    justifyContent: "center",
                    alignItems: "center",
                    flex: 1,
                    transform: 'scale(' + (scaleFactor.toString()) + "," + (scaleFactor.toString()) + ')'
                }}
            >
                <div style={{
                    position: "relative",
                    width: phoneFrameDimensions.width.desktop,
                    height: phoneFrameDimensions.height.desktop
                }}>
                    {videoInPhone(video, 0, 0, 0, 1, backupPhoto)}
                </div>
            </div>
        </div>
    )
}


export const VerticalPhoneMobile = ({ video, backupPhoto, scaleFactorInput, halfMobileInput, banner = undefined, bannerFontSize = undefined }) => {
    const scaleFactor = scaleFactorInput ?? 1.2
    const halfMobile = halfMobileInput ?? false
    const computedBannerFontSize = bannerFontSize ?? (halfMobile ? "6px" : "11px")
    // alert(70 * ((getScreenSize().width ** 0.5) * 0.2 / 400))
    return (
        <div className="about-section-video" style={{

            display: "flex",
            position: "relative",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
            height: "auto",
            width: "auto",
        }}>
            <div
                className="about-section-video-container"
                style={{
                    padding: "4%",
                    objectFit: "contain",
                    height: "auto",
                    width: "auto",
                    display: "flex",
                    position: "relative",
                    justifyContent: "center",
                    alignItems: "center",
                    flex: 1,
                    transform: 'scale(' + (scaleFactor.toString()) + "," + (scaleFactor.toString()) + ')'
                }}
            >
                <div style={{
                    position: "relative",
                    width: phoneFrameDimensions.width.halfMobile,
                    height: phoneFrameDimensions.height.halfMobile
                }}>
                    <FlexiblePhoneStillImage marginHorizontal={"3%"}
                        marginTop={"1%"} image={backupPhoto} videoBorderRadius={(parseFloat((phoneFrameDimensions).height.halfMobile.replace("px", "")) / 12) + "px"} banner={banner} bannerFontSize={computedBannerFontSize}></FlexiblePhoneStillImage>
                </div>
            </div>
        </div>
    )
}


// Horizontal scrolling container for multiple phones
export const HorizontalScrollHero = ({ videos, backupPhotos, scaleFactor, halfMobile }) => {

    const activeIndex = 1

    return (

        <div
            style={{
                display: 'flex',
                gap: '20px',
                height: '100%',
                backgroundColor: "red",
                width: "100%", // Adjust width dynamically based on number of videos
            }}
        >
            {/* {videos.map((video, index) => {
                const isActive = index === activeIndex;
                return (
                    <div
                        key={index}
                        style={{
                            flex: '1 0 auto',
                            minWidth: 'calc(100vw / 2)', 
                            scrollSnapAlign: 'center',
                          
                        }}
                    >
                        <VerticalPhoneMobile
                            video={video}
                            backupPhoto={backupPhotos[index]}
                            scaleFactorInput={scaleFactor}
                            halfMobileInput={halfMobile}
                        />
                    </div>
                );
            })} */}
        </div>

    );
};